import { ResizeGroupBase } from './ResizeGroup.base';
export var ResizeGroup = ResizeGroupBase;
//# sourceMappingURL=ResizeGroup.js.map